import { useState, useEffect } from 'react'
import VALUES from 'core/data-model/constants/values'
import Icon from 'e-submission/components/Icon'
import _ from 'lodash'
import { openPdf } from 'pdf-generation/pdf-opener'
import {
  getSelectedDisplayProduct,
  getSelectedDisplayProductCategory,
  getSelectedDisplayProductCode,
} from 'quick-quote/product-selection/selectors'
import { useSelector } from 'react-redux'
import { iInvestBase64Pdf, iLinkBase64Pdf, iWealthyBase64Pdf } from '../../constants/ilp-pdf-base64'
import { URL_OPEN_VIDEO } from './constants'

const SALE_SHEET_PDF_NAME = {
  RPUDR: iLinkBase64Pdf, // iLink
  SPUL: iInvestBase64Pdf, // iInvest
  RPUL: iWealthyBase64Pdf, // iWealthy
}

const VideoPreviewSection = (props) => {
  const [base64Url, setBase64Url] = useState('')
  const selectedDisplayProduct = useSelector(getSelectedDisplayProduct)
  const selectedDisplayProductCode = useSelector(getSelectedDisplayProductCode)
  const selectedDisplayProductCategory = useSelector(getSelectedDisplayProductCategory)

  useEffect(() => {
    if (selectedDisplayProductCategory === VALUES.INVESTMENT) {
      const pdfBase64 = SALE_SHEET_PDF_NAME[selectedDisplayProductCode]
      setBase64Url(pdfBase64)
    }
  }, [selectedDisplayProductCode, selectedDisplayProductCategory])

  const videoLink = URL_OPEN_VIDEO[selectedDisplayProductCode]

  const handleOpenPdfLink = async (rawPdfBase64) => {
    try {
      const pdfBase64 = rawPdfBase64.replace('data:application/pdf;base64,', '')
      let newBrowserWindow
      const saleSheetFilename = 'SalesSheet.pdf'

      if (window.cordova) {
        openPdf(pdfBase64, newBrowserWindow, saleSheetFilename)
      } else {
        newBrowserWindow = window.open('', '_blank')
        openPdf(pdfBase64, newBrowserWindow)
      }
    } catch (e) {
      console.error('Cannot open pdf file')
    }
  }

  const handleOpenVideoLink = async (urlLink) => {
    try {
      if (window.cordova) {
        var ref = window.cordova.InAppBrowser.open(urlLink, '_self', 'location=no')
        ref.addEventListener('loaderror', function(event) {
          alert('ไม่สามารถเปิดได้ (' + event.message + ')')
        })
      } else {
        window.open(urlLink, '_blank')
      }
    } catch (e) {}
  }

  const isNoVideoLink = _.isEmpty(videoLink)

  return (
    <div className="video-preview-section">
      {!isNoVideoLink && (
        <div>
          <span>ท่านสามารถรับชมโฆษณาข้อมูลผลิตภัณฑ์ หรือ ดาวน์โหลดโบร์ชัวร์ผลิตภัณฑ์</span>
        </div>
      )}
      <div className="link-container">
        {!isNoVideoLink && (
          <div
            onClick={() => {
              handleOpenVideoLink(videoLink)
            }}
            className="video-link"
          >
            <span className="text-link">ข้อมูลผลิตภัณฑ์</span>
            <Icon.previewVideo style={{ width: '26.5px', height: '26.5px' }} />
          </div>
        )}
        <div
          onClick={() => {
            handleOpenPdfLink(base64Url)
          }}
          className="pdf-link"
        >
          <span className="text-link">ดาวน์โหลด Sales Sheet</span>
          <Icon.downloadDocument style={{ width: '22.5px', height: '22.5px' }} />
        </div>
      </div>
    </div>
  )
}

export default VideoPreviewSection
